import React, { useEffect, useRef } from "react";
import "./Explore_By_Category.css";
import Explore_Category_Card from "./explore_category_card/Explore_Category_Card";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import "swiper/css";
import "swiper/css/grid";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Autoplay } from "swiper/modules";
import useIsMobile from "./useIsMobile";
import Common_Heading_Holder from "../../common-components/common_heading_holder/Common_Heading_Holder";

const Explore_By_Category = (props) => {
  const navigate = useNavigate();

  const data = [
    {
      img: "/assets/images/home/explore_category/img1.png",
      product: "Vegetables",
    },
    {
      img: "/assets/images/home/explore_category/img2.png",
      product: "Fruits",
    },
    {
      img: "/assets/images/home/explore_category/img3.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img4.png",
      product: "Baby Care",
    },
    {
      img: "/assets/images/home/explore_category/img5.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img6.png",
      product: "Paan Corner",
    },
    {
      img: "/assets/images/home/explore_category/img5.png",
      product: "Beverages",
    },
    {
      img: "/assets/images/home/explore_category/img6.png",
      product: "Paan Corner",
    },
  ];
  const dispatch = useDispatch();

  const categories = useSelector((state) => state.master.categories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const grouped = [];
  for (let i = 0; i < categories.slice(2).length; i += 2) {
    grouped.push(categories.slice(2).slice(i, i + 2));
  }

  // Ref for horizontal scroll
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 250; // adjust as needed
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // Swiper reference
  const isMobile = useIsMobile();
  return (
    <section className="Explore_By_Category">
      <Common_Heading_Holder headingText={"Explore by Category"} />

      <div className="white_card_div">
        <div className="row">
          <div className="col-xxl-11 col-xl-11 col-lg-10 col-md-11 design_1 category_swiper_holder pe-0">
            {categories?.length > 2 && (
              <Swiper
                modules={[Autoplay]}
                // grid={{ rows: 2, fill: "row" }}
                spaceBetween={10}
                slidesPerView={2}
                // autoplay={{
                //   delay: 2500,
                //   disableOnInteraction: false,
                // }}
                // loop
                breakpoints={{
                  485: { slidesPerView: 3 },
                  768: { slidesPerView: 3.2 },
                  992: { slidesPerView: 3.2 },
                  1200: { slidesPerView: 4 },
                  1400: { slidesPerView: 5.2 },
                }}
                className="categary_grid_slider"
              >
                {categories?.map((item, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className="grid_view"
                    >
                      <Explore_Category_Card
                        data={item}
                        img={item?.image}
                        product={item?.name}
                        id={item?.id}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>

          <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-1 col-sm-12 ps-0">
            <div
              className="gray_div"
              onClick={() => {
                navigate("/shop");
              }}
            >
              <div className="view_more_div">
                <p className="text">View More</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore_By_Category;
